import React, { useState, useContext, useEffect } from "react";
import classNames from "classnames/bind";
import ListLocation from "./ListLocation";
import useFetchLocation from "../../../Location/useFetchLocation";
import Header from "../../../Location/Header";
import { DownIcon, LeftIcon } from "../../../../components/Icons/Icons";
import Filter from "../../../Location/Filter/Filter";
import { Button, Loading, Toast, Skeleton } from "../../../../components";
import SearchFail from "../../../Location/SearchFaild/SearchFail";
import styles from "../Setting.module.css";
import { sorterArray } from "../../../../utils";

const cx = classNames.bind(styles);
const SideBarSetting = ({ isRecord, isApply, setIsApply, onChangeCamera, cameraCode }) => {
  const [isGroup, setIsGroup] = useState(true);
  const [filter, setFilter] = useState([]);
  const [value, setValue] = useState();
  const [listLocation, setListLocation] = useState([]);
  const [isFilter, setIsFilter] = useState(false);
  //eslint-disable-next-line
  const [isSearchFail, setIsSearchFail] = useState(false);
  const [groupCam, setGroupCam] = useState(null);
  const [provinceCode, setProvinceCode] = useState();
  const [districtCode, setDistrictCode] = useState(null)
  const [communeCode, setCommuneCode] = useState(null)
  const [haveVideo, setHaveVideo] = useState(1);

  const handleShowWarehouse = (value) => {
    const data = listLocation.map((item, index) => {
      if (index === value) {
        return {
          ...item,
          isShow: !item.isShow,
          icon: !item.isShow ? <DownIcon /> : <LeftIcon />,
        };
      }
      return {
        ...item,
        isShow: false,
        icon: <LeftIcon />
      };
    });
    setListLocation(data);
  };
  const updateValue = (data) => {
    setValue(data);
  };
  const changeFilter = (data) => {
    setFilter(data);
  };
  const updateIsGroup = (data) => {
    setIsGroup(data);
  };
  const handleFilter = (data) => {
    setIsFilter(!isFilter);
    setFilter(data);
  };
  const handleApply = (e) => {
    setIsApply(!isApply);
  };

  const groups = useFetchLocation(
    "warehouse/get-list-group-warehouse-by-username/",
    "warehouse/get-list-province-warehouse-by-username/",
    isGroup,
    { value, provinceCode, districtCode, communeCode, groupCam },
    isApply,
  );

  useEffect(() => {
    if (filter) {
      filter.forEach((item) => {
        switch (item.type) {
          case 'group':
            setGroupCam(item.name)
            break;
          case 'province':
            setProvinceCode(item.code)
            break;
          case 'district':
            setDistrictCode(item.code);
            break;
          case 'commune':
            setCommuneCode(item.code);
            break;
          case 'record':
            setHaveVideo(item.code)
            break;
          default:
            return 0;
        }
      })
    }
  }, [filter])

  React.useEffect(() => {
    let value;
    if (groups.status === 403) {
      Toast.open('Bạn không có quuyển xem danh sách camera', 'danger')
    }
    if (isGroup && groups.data?.length > 0 && groups?.data[0]?.GROUP_CODE) {
      value = groups.data?.map((item) => {
        return {
          code: item.GROUP_CODE,
          name: item.GROUP_NAME,
          wareHouses: item.LIST_WAREHOUSE,
          icon: <LeftIcon />,
          isShow: false,
        };
      });
    } else if (!isGroup && groups.data?.length > 0 && groups?.data[0]?.PROVINCE_CODE) {
      value = groups.data?.map((item) => {
        return {
          code: item.PROVINCE_CODE,
          name: item.PROVINCE_NAME,
          wareHouses: item.LIST_WAREHOUSE,
          icon: <LeftIcon />,
          isShow: false,
        };
      });
    }
    if (value && value?.length > 0 && value[0].code) {
      const sortValue = sorterArray(value, 'name')
      setListLocation(sortValue);
    } else {
      setListLocation(value)
    }
  }, [groups.data, groups.status, isGroup]);

  useEffect(() => {
    if (isRecord) {
      setFilter([{
        name: 'Có bản ghi',
        code: 1,
        type: 'record'
      }])
    }
  }, [isRecord])
  return (
    <div className={cx("list")}>
      <div id="__notification"></div>
      {isFilter ? (
        <Filter onFilter={handleFilter} fillOn={'video'} isGroup={isGroup} />
      ) : (
        <>
          <Header
            value={value}
            setValue={updateValue}
            filter={filter}
            setFilter={changeFilter}
            handleFilter={handleFilter}
            isGroup={isGroup}
            setIsGroup={updateIsGroup}
            type={"AI"}
            setListCodeCamera={(e) => onChangeCamera(e?.codeCamera, e?.nameCamera)}
          />
          {groups.isLoading ? (
            <div className={cx("loading")}>
              <Skeleton height={48} width={"100%"} />
              <Skeleton height={48} width={"100%"} />
            </div>
          ) : (
            <div className={cx("list-location")}>
              {listLocation && listLocation?.length > 0 && !isSearchFail ? (
                listLocation.map((item, index) => {
                  if (item.wareHouses?.length >= 0) {
                    return (
                      <ListLocation
                        key={index}
                        indexLocation={index}
                        show={item.isShow}
                        onClick={handleShowWarehouse}
                        name={item.name}
                        wareHouses={item.wareHouses}
                        icon={item.icon}
                        code={item.code}
                        value={value}
                        isGroup={isGroup}
                        filter={filter}
                        onChangeCamera={onChangeCamera}
                        cameraCode={cameraCode}
                      />
                    );
                  }
                  return <React.Fragment key={index}></React.Fragment>;
                })
              ) : (
                <SearchFail />
              )}
            </div>
          )}
          {isApply && (
            <div className={cx("apply")}>
              <Button
                title="Áp dụng"
                className={cx("btn")}
                onClick={handleApply}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default SideBarSetting;
